import { useEffect, useRef } from 'react'
import authService from '@/services/authService'
import apiClient from '@/services/api'
import { useAuthStore } from '@/store/authStore'
import { PageSpinner } from './components/atoms/PageSpinner'

export function AuthBootstrap({ children }: { children: React.ReactNode }) {
  const { setUser, setStatus } = useAuthStore()
  const status = useAuthStore((s) => s.status)       
  const attempted = useRef(false)

  useEffect(() => {
    if (attempted.current) return
    attempted.current = true

    setStatus('loading')

    const init = async () => {
        try {
            const token = await authService.refreshToken()

            // Pass token explicitly — store isn't updated yet at this point
            const { data } = await apiClient.get('/auth/me/', {
            headers: { Authorization: `Bearer ${token}` }
            })

            setUser(data.data, token)  // now store gets updated
        } catch {
            setStatus('unauthenticated')
        }
    }

    init()
  }, [])

  // Block rendering until we know auth state
  if (status === 'idle' || status === 'loading') {
    return <PageSpinner />
  }

  return <>{children}</>
}